class loadingBar {
  init() {
    this.progressBar = document.querySelector('.loading-bar');
    this.progressBarInner = document.querySelector('.loading-bar-inner');
  }

  show() {
      this.progressBar.classList.add('show');
  }

  hide() {
      this.progressBar.classList.remove('show');
  }

  setProgress(value) {
    this.progressBarInner.style.width = `${value}%`;
    if (value >= 100) {
      this.hide();
    }
  }

  setIndeterminate() {
    this.progressBarInner.classList.add('loading-bar-indeterminate');
  }

  setDeterminate() {
    this.progressBarInner.classList.remove('loading-bar-indeterminate');
  }
}

module.exports = new loadingBar();